import xs from "xstream"
import { div, label, input, button, br } from "@cycle/dom"
import * as R from "ramda"

import {
  CheckResult,
  RecessForm,
} from "../../../../interface"

import {
  createTextArea,
  createTextInput,
} from "../../../common"

const drawRecessType = (userForm: RecessForm, errorCheck: any, readOnly: boolean) => {
  const err: CheckResult = R.propOr({}, "when", errorCheck)
  const valid = (err.check || readOnly) ? "" : "is-invalid"

  const r1Checked = R.prop("when", userForm) === "即日"
  const r2Checked = R.prop("when", userForm) === "年度末退会"
  return div(".col-md-6", [
    label(".form-label", ["退会時期※"]),
    div(".form-check", [
      label({ attrs: { for: "r1" } }, [
        input(`#r1.form-check-input.${valid}`, {
          attrs: { type: "radio", name: "when", value: "即日", disabled: readOnly },
          props: { checked: r1Checked },
        }),
        "即日"
      ]),
      div(`${ r1Checked ? ".fw-bold.text-danger" : ".form-text" }`, ["すでにお納め頂いている会費は、学会定款の定めによりご返却出来ませんのでご了承下さい。退会後、学会誌の閲覧を含む全ての郵送物の送付が停止されます。"])
    ]),
    div(".form-check", [
      label({ attrs: { for: "r2" } }, [
        input(`#r2.form-check-input.${valid}`, {
          attrs: { type: "radio", name: "when", value: "年度末退会", disabled: readOnly },
          props: { checked: r2Checked },
        }),
        "年度末退会"
      ]),
      div(`${ r2Checked ? ".fw-bold.text-danger" : ".form-text" }`, ["当該年度の3月31日付で退会手続きを行います。従って年度内に発刊される学会誌の閲覧を含む全ての案内が送付されます。"])
    ]),
    err.check ? null : div(".invalid-feedback.d-block", [err.message]),
  ])
}

export const view = (
  userForm$: xs<RecessForm>,
  errorCheck$: xs<any>,
  zipMsg$: xs<string | null>,
  readOnly = false,
) =>
  xs
    .combine(userForm$, errorCheck$, zipMsg$)
    .map(
      ([userForm, errorCheck, _zipMsg]: [
        RecessForm,
        any,
        string | null,
      ]) => {
        const disabled = R.find(
          (arr) => arr[1].check === false,
          R.toPairs(errorCheck),
        )
          ? true
          : false
        const gutter = readOnly ? "" : ".mt-2"
        return div([
          div(".form.mt-1", [
            div(`.row${gutter}`, [
              readOnly ? null : div(".px-2.mb-2", [
                div(".border.border-danger.border-2.p-2.fw-bold", [
                  div(".form-text", [
                    "本会の事業年度は4月1日～3月31日を区切りとしております。", br(),
                    "本会の会費は年単位の会費として納入いただいております。", br(),
                    "ご入会時にもご案内いたしておりますが、本会では事業年度開始後、日本生殖医学会雑誌の電子配布が開始されました時点で（4月中旬～5月上旬ごろ）、該当年度は会員としてのサービスをお受け取りになる意思があるものとみなし、6月に会費請求をさせていただく流れとなっておりますのでご了承ください。",
                  ]),
                  div(".form-text", ["なお、当該年度の日本生殖医学会雑誌電子配布後（例年4月末頃）に退会のご連絡を頂いた場合は、本年度分を含め会費を完納いただいたうえで、退会となります。会費滞納分があるままでのご退会は受付いたしかねますのでご了承ください。"]),
                ]),
              ]),
            ]),
            readOnly ? null : div(".row", [
              div(".col-md-6.caution", ["※は必須入力です。"]),
            ]),
            div(`.row${gutter}`, [
              createTextInput("telWithdrawal", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              drawRecessType(userForm, errorCheck, readOnly),
            ]),
            div(`.row${gutter}`, [
              createTextArea("reason", readOnly)(userForm, errorCheck),
            ]),
            div(`.row${gutter}`, [
              createTextArea("bikou", readOnly)(userForm, errorCheck),
            ]),
            div(".d-grid.gap-3.mt-4", [
              div(".col.col-md-4", [
                readOnly
                  ? button(
                    "#btnSend.btn.btn-danger.w-100",
                    { props: { disabled: disabled } },
                    ["退会申請を行う"],
                  )
                  : button(
                    "#btnConfirm.btn.btn-primary.w-100",
                    { props: { disabled: disabled } },
                    ["申請内容を確認する"],
                  ),
              ]),
              div(".col.col-md-4", [
                button( "#btnReturn.btn.btn-success.w-100", ["戻る"]),
              ]),
            ]),
          ]),
        ])
      },
    )
